export default vm => {
  console.log(vm); //vue的this对象
  return {
    index: false,
    align: "center",
    headerAlign: "center",
    height: "auto",
    calcHeight: 20,
    labelWidth: 130,
    header: false, // 控制操作按钮
    border: true,
    stripe: true,
    selection: true,
    editBtn: false,
    delBtn: false,
    tip: false,
    menu: true, // 表格操作栏
    column: [
      {
        label: "配置分类",
        align: "left",
        prop: "ptype",
        overHidden: true,
        dicUrl: "/lebo-system/dict/dictionary?code=player-config",
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        dicFormatter: res => {
          console.log("🚀 ~ res:", res);
          const list = res.data.map(item => {
            return {
              ...item,
              dictKey: Number(item.dictKey)
            };
          });
          return list;
        }
      },
      {
        label: "配置名称",
        prop: "pname",
        overHidden: true
      },
      {
        label: "KEY",
        prop: "pkey",
        overHidden: true
      },
      {
        label: "配置说明",
        prop: "pvalue",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: true
      },
      {
        label: "创建时间",
        prop: "createTime",
        overHidden: true
      }
    ]
  };
};
